<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-card
        v-bind="attrs"
        v-on="on"
        height="55px"
        outlined
        elevation="0"
        class="rounded-lg d-flex px-3 align-center justify-space-between"
      >
        <span>
          <span class="red--text"><strong>* </strong></span>{{ textPlace }}
        </span>
        <v-icon>mdi-crosshairs-gps</v-icon>
      </v-card>
    </template>

    <v-card>
      <v-card-title
        class="text-body-1 text-md-h6 pt-8 variantOne--text d-flex justify-space-between"
      >
        <span>
          Select Your Property Location
        </span>

        <v-btn
          @click="dialog = false"
          class="font-weight-black grey rounded-lg"
          width="10px"
          height="25px"
        >
          x
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-card
          class="my-3"
          height="40"
          elevation="0"
          outlined
          width="min-content"
        >
          <GmapAutocomplete
            @place_changed="setPlace"
            autofocus
            placeholder="Property Location"
            class="mb-4 mx-auto pa-2 ps-2"
          />
        </v-card>
        <gmap-map
          :options="{
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
          }"
          :center="center"
          :zoom="12"
          style="width: 100%; height: 400px"
        >
          <gmap-marker
            @change="dragMarker"
            @dragend="dragMarker"
            :key="1"
            :draggable="true"
            :position="{ ...center, label: 'marker' }"
          ></gmap-marker>
        </gmap-map>
      </v-card-text>

      <v-divider></v-divider>
      <div class="d-flex justify-end py-4 px-6">
        <v-btn color="primary" @click="dialog = false" elevation="0">
          Add Location
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    latLng: {
      type: Object
    }
  },
  created() {
    if (this.latLng) {
      this.center = { lat: this.latLng.latitude, lng: this.latLng.longitude };
    }
  },
  data() {
    return {
      center: { lat: 0, lng: 0 },
      dialog: false,
      textPlace: "Select Location",
      areas: []
    };
  },
  watch: {
    latLng(){
      this.center = { lat: this.latLng.latitude, lng: this.latLng.longitude };
    },
    center: {
      handler() {
        this.setText();
        this.$emit("setLatLng", this.center);
      },
      deep: true
    }
  },
  methods: {
    setText() {
      if (this.center && this.center.lat && this.center.lng) {
        this.textPlace = ` latitude : ${this.center.lat.toFixed(
          8
        )}  longitude : ${this.center.lng.toFixed(8)}`;
      } else {
        this.textPlace = "Please select the location";
      }
    },
    setPlace(value) {
      this.center.lat = value.geometry.location.lat();
      this.center.lng = value.geometry.location.lng();
    },
    dragMarker(value) {
      this.center.lat = value.latLng.lat();
      this.center.lng = value.latLng.lng();
    }
  }
};
</script>
<style scoped>
.pac-container:after {
  content: none !important;
}
.v-btn {
  min-width: 0 !important;
}
</style>
